import { AssignAdvocatesToStoryMeta, AssignAdvocatesToStoryPayload } from 'types/store/AssignAdvocatesToStory';
import { createAsyncReducer } from 'utils/Redux';

import { assignAdvocatesToStoryActions } from '../actions';

export default createAsyncReducer<AssignAdvocatesToStoryMeta, AssignAdvocatesToStoryPayload>(assignAdvocatesToStoryActions);
